// extracted by mini-css-extract-plugin
export default {"FormDetail":"FormDetail_FormDetail__NW1FY","FormDetail__active":"FormDetail_FormDetail__active__I9Ywm"};